<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import { debounce } from '@/utils/util'
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme

export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 600)
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions({ city, deviceCount } = {}) {
      this.chart.setOption({
        backgroundColor: 'transparent', // 设置透明背景
        grid: {
          top: 30,
          bottom: 30,
          right: 0,
          left: 30
        },
        colorBy: 'series',
        xAxis: {
          type: 'category',
          data: city,
          axisLine: {
            lineStyle: { type: 'dashed', color: '#898a8a' }
          }
        },
        tooltip: {
          trigger: 'item'
        },
        yAxis: {
          type: 'value',
          splitArea: false,
          axisLine: {
            lineStyle: { type: 'dashed', color: '#898a8a' }
          },
          splitLine: {
            show: true,
            lineStyle: { type: 'dashed', color: '#2b2c2c' }
          }
        },
        series: [
          {
            data: deviceCount,
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              borderRadius: [5, 5, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#5DD6D2' },
                { offset: 1, color: '#6CCC63' }
              ])
            }
          }
        ]
      })
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    }
  }
}
</script>
